export default "__VITE_ASSET__BmRpPkEU__"